import type { Accessor, Setter } from "solid-js";

type Props = {
	overlayContentVisible: Accessor<boolean>;
	setOverlayContentVisible: Setter<boolean>;
};

/**
 * Overlay to toggle the visibility of the video details.
 */
export const ToggleOverlay = (props: Props) => {
	return (
		<button
			type="button"
			class="board-video-overlay"
			classList={{
				"board-video-overlay--content-hidden": !props.overlayContentVisible(),
			}}
			aria-expanded={props.overlayContentVisible()}
			aria-label={
				props.overlayContentVisible()
					? "Hide video details"
					: "Show video details"
			}
			onClick={() => props.setOverlayContentVisible((visible) => !visible)}
		/>
	);
};
